import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suprimir errores internos conocidos de Firestore SDK que no afectan la funcionalidad
// Bug conocido: https://github.com/firebase/firebase-js-sdk/issues

// Helper para detectar errores de Firestore
const isFirestoreInternalError = (message: string): boolean => {
  return message.includes('INTERNAL ASSERTION FAILED') && message.includes('FIRESTORE');
};

// Interceptar console.error para suprimir errores de Firestore
const originalConsoleError = console.error;
console.error = (...args) => {
  const message = args[0]?.toString() || '';
  if (isFirestoreInternalError(message)) {
    // Silenciosamente ignorar estos errores
    return;
  }
  originalConsoleError.apply(console, args);
};

// Suprimir errores no capturados de Firestore
window.addEventListener('error', (event) => {
  if (event.message && isFirestoreInternalError(event.message)) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    return false;
  }
}, true); // Capturar en fase de captura

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.message || event.reason?.toString() || '';
  if (isFirestoreInternalError(reason)) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
}, true);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
